import './style.scss';
import { ChangePasswordProps, useChangePassword } from './hooks';
import { PasswordInput } from 'views/mutual/passwordInput';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { ResultHeader } from 'views/mutual/result';

export const ChangePassword = () => {
  return (
    <section className="changePasswordPage">
      <ChangePasswordBody />
    </section>
  );
};

export const ChangePasswordBody = (props: ChangePasswordProps) => {
  const { formik } = useChangePassword(props);

  return (
    <div className="changePassword">
      <div className="changePassword_inputWrapper">
        <ResultHeader label="現在のパスワード" />
        <div className="changePassword_inputWrapper_input">
          <PasswordInput
            name="currentPassword"
            value={formik.values.currentPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="半角英数字記号12~64文字で入力してください"
          />
          <div className="errorRed">
            {formik.touched.currentPassword && formik.errors.currentPassword && formik.errors.currentPassword}
          </div>
        </div>
      </div>

      <div className="changePassword_inputWrapper">
        <ResultHeader label="新しいパスワード" />
        <div className="changePassword_inputWrapper_input">
          <PasswordInput
            name="newPassword"
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="半角英数字記号12~64文字で入力してください"
          />
          <div className="errorRed">
            {formik.touched.newPassword && formik.errors.newPassword && formik.errors.newPassword}
          </div>
        </div>
      </div>

      <div className="changePassword_inputWrapper">
        <ResultHeader label="新しいパスワード（確認用）" />
        <div className="changePassword_inputWrapper_input">
          <PasswordInput
            name="confirmPassword"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="半角英数字記号12~64文字で入力してください"
          />
          <div className="errorRed">
            {formik.touched.confirmPassword && formik.errors.confirmPassword && formik.errors.confirmPassword}
          </div>
        </div>
      </div>

      <div className="buttonWrapper">
        <Button
          label="パスワードを変更"
          type={ButtonType.Button}
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.large}
          onClick={formik.handleSubmit}
        />
      </div>
    </div>
  );
};
